import React from "react";
import FirstNightMarket from "./components/nightmarket/FirstNightMarket";
import SecondNightMarket from "./components/nightmarket/SecondNightMarket";
import ThirdNightMarket from "./components/nightmarket/ThirdNightMarket";
import FourthNightMarket from "./components/nightmarket/FourNightMarket";
import FifthNightMarket from "./components/nightmarket/FifthNightMarket";

const NightMarket = () => {
  return (
    <>
      <FirstNightMarket />
      <SecondNightMarket />
      <ThirdNightMarket />
      <FourthNightMarket />
      <FifthNightMarket />
    </>
  );
};

export default NightMarket;
